"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, CircleCheck as CheckCircle2, PhoneCall, ShieldCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const features = [{
  id: 1,
  text: "Apoio técnico especializado e dimensionamento à medida"
}, {
  id: 2,
  text: "Representação oficial Spraying Systems Co."
}, {
  id: 3,
  text: "Resposta rápida e acompanhamento em fábrica"
}];
export default function Callout() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-3xl bg-primary px-6 py-12 text-primary-foreground shadow-2xl sm:px-12 md:py-16 lg:px-16">
          {/* Subtle decorative background glow and geometry */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 size-96 rounded-full bg-secondary/20 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -left-24 size-96 rounded-full bg-secondary/10 blur-3xl" />

          <div className="relative z-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
            {/* Left/Main copy column */}
            <div className="space-y-6 lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 px-3.5 py-1 text-xs font-medium tracking-wide text-primary-foreground">
                <ShieldCheck className="size-4 text-secondary-foreground" />
                <span>Especialistas em Pulverização desde 1937</span>
              </div>

              <h2 className="text-3xl font-semibold tracking-tight text-primary-foreground sm:text-4xl lg:text-5xl">
                Otimize os seus processos industriais com tecnologia de precisão.
              </h2>

              <p className="max-w-xl text-base text-primary-foreground/80 sm:text-lg">
                Fale com a equipa técnica da Eurocontrol. Analisamos a sua aplicação e apresentamos a solução mais eficiente para reduzir custos e consumo.
              </p>

              {/* Value points list */}
              <div className="space-y-3 pt-2">
                {features.map((item, index) => <div key={item.id} data-index={index} className="flex items-center gap-3 text-sm text-primary-foreground/90 sm:text-base">
                    <CheckCircle2 className="size-5 shrink-0 text-secondary-foreground" />
                    <span>{item.text}</span>
                  </div>)}
              </div>
            </div>

            {/* Right action column */}
            <div className="flex flex-col items-start gap-4 rounded-2xl bg-primary-foreground/5 p-6 sm:p-8 lg:col-span-5 lg:items-center lg:text-center">
              <div className="size-12 rounded-full bg-secondary/20 flex items-center justify-center text-primary-foreground mb-2">
                <PhoneCall className="size-6" />
              </div>

              <h3 className="text-xl font-semibold text-primary-foreground">
                Solicite uma proposta técnica
              </h3>

              <p className="text-sm text-primary-foreground/75 mb-2">
                Envie-nos os detalhes do seu projeto para receber uma recomendação detalhada de bicos e sistemas.
              </p>

              <div className="w-full flex flex-col sm:flex-row lg:flex-col gap-3">
                <Button asChild size="lg" className="w-full bg-secondary text-secondary-foreground shadow-md hover:bg-secondary/90 text-base font-semibold transition-[background-color,box-shadow]">
                  <Link to="/ContactsPage" className="inline-flex items-center justify-center gap-2">
                    <span>Solicite um orçamento</span>
                    <ArrowRight className="size-4" />
                  </Link>
                </Button>

                <Button asChild variant="outline" size="lg" className="w-full border-primary-foreground/20 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground text-sm transition-colors">
                  <Link to="/ProductsPage">
                    Consultar catálogo de produtos
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}